import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=657971e3"
import script from "./Data.vue?vue&type=script&lang=ts"
export * from "./Data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports